import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { RequestExamFormComponent } from './request-exams-form.component';

// routing
const routes: Routes = [
  {
    path: 'request-exams',
    component: RequestExamFormComponent,
    data: { publicPage: true }
  },
];

@NgModule({
  declarations: [RequestExamFormComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    ReactiveFormsModule
  ]
})
export class RequestExamsModule {}
